import type { RegisteredServices } from '@/core/container/types'

export const TICKET_MESSAGES_PER_PAGE = 10
export const TICKET_MESSAGES_LIST_ID = 'ticketMessagesListId' as RegisteredServices
export const TICKET_ID_TYPE_QUERY_PARAM = 'idType'
export const MESSAGE_ID_QUERY_PARAM = 'messageId'
export const MESSAGE_PAGE_FROM_END_QUERY_PARAM = 'msgPage'

export const enum TicketIdType {
  ENTITY = 'ENTITY',
  WORKSPACE = 'WORKSPACE',
}

export const getTicketMessagesInTicketFacetKey = (ticketId: string | number) => `inTicket-${ticketId}`
